// extracted by mini-css-extract-plugin
export default {"price":"Q7-z","onSale":"R7-z","msrpLabelPrice":"S7-z","msrpLabel":"T7-z","originalPrice":"U7-z","percentOff":"V7-z"};